import moment, { Moment } from 'moment-timezone'
import { ApplicantAvailability } from '../types/applicantAvailability'
import { daysInThisMonth } from './dates'

const getTimeAsMinutes = (time: Moment) => {
  return time.hours() * 60 + time.minutes()
}

const getAvailabilitiesOnSpesificDate = (
  availabilities: ApplicantAvailability[],
  date: string | Moment
): ApplicantAvailability[] => {
  return availabilities.filter((availability) => {
    const compareDate = moment(date)
    const startDate = moment(availability.startDate)
    return compareDate.format('DD:MM') === startDate.format('DD:MM')
  })
}
const getFutureAvalibilities = (
  availabilities: ApplicantAvailability[],
  date: Moment
) => {
  return availabilities.filter((avaliablity) => {
    return moment(avaliablity.startTime).isAfter(
      moment(date).date(1).hours(0).minutes(0).add(1, 'month')
    )
  })
}
const getPastAvalibilities = (
  availabilities: ApplicantAvailability[],
  date: Moment
) => {
  const monthDate = daysInThisMonth(date)
  return availabilities.filter((avaliablity) => {
    return (
      moment(avaliablity.startTime).isBefore(
        moment(date).date(monthDate).hours(23).minutes(0).add(-1, 'month')
      ) && moment(avaliablity.startTime).isAfter(moment().hour(1))
    )
  })
}
const getAvailabilitesOnSpesificTime = (
  availabilities: ApplicantAvailability[],
  time: string | Moment
): ApplicantAvailability[] => {
  const suggestedApplicationIds: string[] = []

  const result = availabilities.filter((availability) => {
    const compareTime = getTimeAsMinutes(moment(time))
    const startTime = getTimeAsMinutes(moment(availability.startTime))
    const endTime = getTimeAsMinutes(moment(availability.endTime))

    if (compareTime < startTime || compareTime >= endTime) {
      return false
    }
    /** make sure that same applicant doesnt get marked twice */
    if (suggestedApplicationIds.includes(availability.applicationId)) {
      return false
    }
    suggestedApplicationIds.push(availability.applicationId)
    return true
  })

  return result
}
const getAvailabilitesFromSpesificDate = (
  availabilities: ApplicantAvailability[],
  date: string | Moment
): { startTime: Moment; endTime: Moment }[] => {
  const array: { startTime: Moment; endTime: Moment }[] = []
  availabilities.forEach((e) => {
    moment(e.startDate).format('DD/MM/YYYY') ===
      moment(date).format('DD/MM/YYYY') &&
      array.push({ startTime: moment(e.startTime), endTime: moment(e.endTime) })
  })
  return array
}

const getApplicationIdsFromApplicantAvailabilities = (
  availabilities: ApplicantAvailability[]
): string[] => {
  return availabilities.map((availability) => availability.applicationId)
}

export {
  getAvailabilitiesOnSpesificDate,
  getFutureAvalibilities,
  getPastAvalibilities,
  getAvailabilitesOnSpesificTime,
  getAvailabilitesFromSpesificDate,
  getApplicationIdsFromApplicantAvailabilities
}
